import loading from "./loading.svg";
import styles from "./style.module.css";
export default function Loading({ className = "" }) {
  return (
    <div className={`text-center ${className}`}>
      <img src={loading} className={styles.loadingIcon} alt="loading" />
    </div>
  );
}
